<div [hisDdKey]="hisDdKey"  #dDFieldset>
	<p-panel header="{{ hisDdKey | hisUi }}">

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>

		<!-- no record found -->
		<div [class]="dDFieldset.required ? 'requireMessage' : 'infoMessage'" *ngIf="!relevantUsages.length"
		    [innerHTML]="'fs.res.researchInfrastructure.ResearchInfrastructure.no' + i18nKey + 'Assigned' | hisUi">
		</div>

		<button #content (click)="addUsage()" hisImage="plus_circ_green" class="transparent">
            <span>{{ 'fs.res.researchInfrastructure.ResearchInfrastructure.assign' + i18nKey | hisUi }}</span>
		</button>

		<p-table *ngIf="relevantUsages.length > 0" [value]="relevantUsages">
			<ng-template pTemplate="header">
				<tr>
					<th [pSortableColumn]="'usageYear'" [hisDdKey]="'fs.res.researchInfrastructure.ResearchInfrastructureUsage.usageYear'"  #dDYear>
						{{ 'fs.res.researchInfrastructure.ResearchInfrastructureUsage.usageYear' | hisUi }}
						<p-sortIcon *ngIf="relevantUsages.length > 1" [field]="'usageYear'"></p-sortIcon>
					</th>
					<th [pSortableColumn]="'usageAmount'" [hisDdKey]="hisDdKey + 'Amount'"  #dDAmount>
						{{ hisDdKey + 'Amount' | hisUi }}
						<p-sortIcon *ngIf="relevantUsages.length > 1" [field]="'usageAmount'"></p-sortIcon>
					</th>
					<th>{{ 'common.actions' | hisUi }}</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-usage let-index="rowIndex">
			    <tr>
			    	<td class="alignRight">{{usage.usageYear}}</td>
			    	<td class="alignRight">{{usage.usageAmount}}</td>
			     	<td class="singleLine">
						<button (click)="editUsage(usage, index)" hisImage="PENCIL" class="icon"
                            [title]="'fs.res.researchInfrastructure.ResearchInfrastructure.edit'+i18nKey|hisUi">
                        </button>
						<button (click)="deleteUsage(usage)" hisImage="DELETE" class="icon"
                            [title]="'fs.res.researchInfrastructure.ResearchInfrastructure.delete'+i18nKey|hisUi">
                        </button>
			     	</td>
			    </tr>
			</ng-template>

		</p-table>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>
	</p-panel>
	
</div>

<res-research-infrastructure-edit-usage-numbers-dialog *ngIf="visibility" [(visibility)]="visibility"
    [(researchInfrastructureUsage)]="researchInfrastructureUsage"
    [researchInfrastructureUsageType]="researchInfrastructureUsageType"
    (researchInfrastructureUsageChange)="researchInfrastructureUsageChange($event)"
    [i18nKey]="i18nKey"
    [hisDdKey]="hisDdKey">
</res-research-infrastructure-edit-usage-numbers-dialog>
